<template>
  <v-dialog :value="value" max-width="720" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="headline primary white--text">
        نتائج التحويل
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-tabs v-model="activeTab" background-color="transparent" grow>
          <v-tab>
            <v-icon left small color="success">mdi-check-circle</v-icon>
            نجح ({{ successCount }})
          </v-tab>
          <v-tab>
            <v-icon left small color="orange darken-2">mdi-alert-circle</v-icon>
            مكرر ({{ duplicateCount }})
          </v-tab>
          <v-tab>
            <v-icon left small color="error">mdi-close-circle</v-icon>
            فشل ({{ failedCount }})
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" class="mt-3">
          <v-tab-item>
            <v-simple-table v-if="successCount" dense>
              <thead>
                <tr>
                  <th>معرف الطلب</th>
                  <th>معرف العميل</th>
                  <th>الجوال</th>
                  <th>الرسالة</th>
                  <th>إجراء</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in result.success" :key="'s-' + row.submission_id">
                  <td>{{ row.request_id }}</td>
                  <td>{{ row.customer_id }}</td>
                  <td dir="ltr">{{ formatSaudiMobile(row.mobile) }}</td>
                  <td>{{ row.message }}</td>
                  <td>
                    <router-link
                      v-if="row.request_id"
                      :to="{ name: 'request_details', params: { id: row.request_id } }"
                      target="_blank"
                      class="result-link"
                    >
                      فتح الطلب
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <p v-else class="text-center grey--text py-6 mb-0">لا توجد نتائج ناجحة</p>
          </v-tab-item>

          <v-tab-item>
            <v-simple-table v-if="duplicateCount" dense>
              <thead>
                <tr>
                  <th>معرف الإرسال</th>
                  <th>الجوال</th>
                  <th>الرسالة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in result.duplicate" :key="'d-' + row.submission_id">
                  <td>{{ row.submission_id }}</td>
                  <td dir="ltr">{{ formatSaudiMobile(row.mobile) }}</td>
                  <td>{{ row.message }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <p v-else class="text-center grey--text py-6 mb-0">لا توجد نتائج مكررة</p>
          </v-tab-item>

          <v-tab-item>
            <v-simple-table v-if="failedCount" dense>
              <thead>
                <tr>
                  <th>معرف الإرسال</th>
                  <th>الجوال</th>
                  <th>الرسالة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in result.failed" :key="'f-' + row.submission_id">
                  <td>{{ row.submission_id }}</td>
                  <td dir="ltr">{{ formatSaudiMobile(row.mobile) }}</td>
                  <td>{{ row.message }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <p v-else class="text-center grey--text py-6 mb-0">لا توجد نتائج فاشلة</p>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="close">إغلاق</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatSaudiMobile } from "@/utils/fundingFormSubmissions";

export default {
  name: "ConvertResultModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: () => ({ success: [], duplicate: [], failed: [] }),
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    successCount() {
      return (this.result.success || []).length;
    },
    duplicateCount() {
      return (this.result.duplicate || []).length;
    },
    failedCount() {
      return (this.result.failed || []).length;
    },
  },
  watch: {
    value(open) {
      if (open) {
        if (this.successCount) this.activeTab = 0;
        else if (this.duplicateCount) this.activeTab = 1;
        else if (this.failedCount) this.activeTab = 2;
        else this.activeTab = 0;
      }
    },
  },
  methods: {
    formatSaudiMobile,
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.result-link {
  color: #3f0e40;
  font-weight: 600;
  text-decoration: none;
}
.result-link:hover {
  text-decoration: underline;
}
</style>
